import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from '../toast-container/toast.service';

@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule],
})
export class PasswordDialogComponent {
  private ngbModalRef = inject(NgbActiveModal);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);

  public password = '';

  protected close() {
    this.ngbModalRef.close();
  }

  protected copyToClipboard(password) {
    navigator.clipboard.writeText(password).then(
      () => {
        this.toastService.success(
          this.translateService.instant('toastr.copiedToClipboardMessage'),
          this.translateService.instant('toastr.copiedToClipboardTitle')
        );
      },
      (err) => {
        this.toastService.danger(
          this.translateService.instant('shared.clipboard.copyFailed')
        );
      }
    );
  }
}
